module.exports = __webpack_public_path__ + "static/media/icon-governance.95ac9227.png";